import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { formatINR } from "@/lib/format";

export const ComparableListings = ({ propertyId }) => {
  const [list, setList] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!propertyId) return;
    api.get(`/properties/${propertyId}/comparables`, { params: { limit: 3 } })
      .then(({ data }) => setList(data))
      .catch(() => setList([]))
      .finally(() => setLoaded(true));
  }, [propertyId]);

  if (!loaded) return null;
  if (list.length === 0) return null;

  return (
    <div className="p-5 rounded-2xl border border-[var(--line)] bg-white" data-testid="comparable-listings">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs uppercase tracking-wider font-semibold text-[var(--ink-muted)]">Nearby Comparables</span>
        <span className="text-[10px] text-[var(--ink-muted)]">Same locality</span>
      </div>
      <div className="space-y-3">
        {list.map((c) => (
          <Link
            key={c.id}
            to={`/property/${c.id}`}
            className="flex gap-3 p-2 rounded-xl hover:bg-[var(--surface)] transition-colors"
            data-testid={`comparable-${c.id}`}
          >
            <div className="w-16 h-16 shrink-0 rounded-lg overflow-hidden bg-[var(--surface)]">
              {c.images?.[0] && <img src={c.images[0]} alt="" className="w-full h-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-serif text-sm text-[var(--teak)] truncate">{c.title}</div>
              <div className="text-[11px] text-[var(--ink-muted)]">{c.bhk} BHK · {c.area_sqft} sq.ft</div>
              <div className="font-mono text-sm font-bold text-[var(--primary)] mt-0.5">{formatINR(c.price, c.listing_type)}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
